import { axiosInstance } from './config';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const rubricsApi = {
    generateRubric: async (competencies, customPrompt) => {
        const response = await axiosInstance.post('/rubrics/generate', {
            competencies,
            customPrompt
        });
        return response.data.data;
    },

    createRubric: async (sessionId) => {
        const response = await axiosInstance.post('/rubrics', {
            session_id: sessionId,
        });
        return response.data.data;
    },
    
    getRubricsBySessionId: async (sessionId) => {
        if (!sessionId) return [];
        const response = await axiosInstance.get(`/rubrics/session/${sessionId}`);
        return response.data.data;
    }
};

/**
 * Hook for generating a rubric
 * @returns {Object} Mutation object for generating a rubric
 */
export const useGenerateRubric = () => {
    return useMutation({
        mutationFn: ({ competencies, customPrompt }) => 
            rubricsApi.generateRubric(competencies, customPrompt)
    });
};

/**
 * Hook for creating a rubric
 * @returns {Object} Mutation object for creating a rubric
 */
export const useCreateRubric = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: ({ sessionId }) => 
            rubricsApi.createRubric(sessionId),
        onSuccess: (_, variables) => {
            // Invalidate the session rubrics query to refresh the list
            queryClient.invalidateQueries(['rubrics', variables.sessionId]);
        }
    });
};

/**
 * Hook for fetching rubrics by session ID
 * @param {string} sessionId - The session ID
 * @returns {Object} Query object for fetching rubrics
 */
export const useSessionRubrics = (sessionId) => {
    return useQuery({
        queryKey: ['rubrics', sessionId],
        queryFn: () => rubricsApi.getRubricsBySessionId(sessionId),
        enabled: !!sessionId
    });
}; 